/* eslint-disable react/prop-types */

/* eslint-disable indent */

import React, { useEffect, useState, useRef, useCallback } from "react";

import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormControlLabel,
  Radio,
  Button,
  RadioGroup,
  DialogActions,
  TextField,
  FormControl,
  FormLabel,
  Checkbox,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import icons from "../../../../../assets/icons/icon-collection.svg";

import "./applicant.css";

import { ternaryResolver } from "../../../../../utils/helpers";

import { logProfileVisits } from "../../../../../redux/actions/insightActions";

import { getOtherUserAction, clearOtherUserAction } from "../../../../../redux/actions/profileActions";

import {
  getAllExperienceAction,
  getSingleExperienceAction,
} from "../../../../../redux/actions/experienceAction";

import CustomButton from "../../../../../components/CustomButton";

import CustomModal from "../../../../../components/CustomModal";

import { uploadFile } from "../../../../../utils/helpers";

import BackButton from "../../../../../components/BackButton";

// import Button from "react-bootstrap";

import CustomTextArea from "../../../../../components/CustomTextArea";

import { SectionLoader } from "../../../../../components/PageLoader";

import { func } from "prop-types";

import { useDispatch, useSelector } from "react-redux";

import {
  clearUpdated,
  declineApplication,
  getJobApplicants,
  hireApplicant,
  updateApplication,
  updateApplicantNote,
  getApplicantNote,
} from "../../../../../redux/actions/insightActions";

import { useHistory, useParams } from "react-router-dom";

import { postHiring } from "../../../../../redux/actions/jobActions";

import { getJob } from "../../../../../redux/actions/jobActions";

import CustomInput from "../../../../../components/CustomInput";

import CustomSearchInput from "../../../../../components/CustomSearchInput";

import cogoToast from "cogo-toast";

import DocumentViewer from "./DocumentViewer";
import ResumeHoverPreview from "./ResumeHoverPreview";

import { bulkMoveCandidates } from "../../../../../services/bulkCandidateService";

import httpRequest from "../../../../../ajax";

import ViewDetails from "../../../Home/Modal/ViewDetails";

const getApplicationTimingInfo = (dateString) => {
  if (!dateString) return null;

  const createdDate = new Date(dateString);

  if (Number.isNaN(createdDate.getTime())) return null;

  const today = new Date();

  const startOfToday = new Date(
    today.getFullYear(),

    today.getMonth(),

    today.getDate(),
  );

  const startOfCreated = new Date(
    createdDate.getFullYear(),

    createdDate.getMonth(),

    createdDate.getDate(),
  );

  const diffMs = startOfToday - startOfCreated;

  const diffDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));

  if (diffDays === 0) {
    return { label: "New", bgColor: "#28a745", uppercase: true };
  }

  const dayLabel = diffDays === 1 ? "1 day" : `${diffDays} days`;

  return {
    label: `Applied ${dayLabel} ago`,

    bgColor: "#6c757d",

    uppercase: false,
  };
};

const Reason = ({ setMessage }) => {
  const [reason, setReason] = useState("");

  const handleChangeReason = ({ target: { value } }) => {
    setReason(value);

    setMessage(value);
  };

  return (
    <div className="mb-3">
      <CustomTextArea
        placeholder=" Enter Additional Message to candidate (optional)"
        onChange={handleChangeReason}
        value={reason}
        label=""
        id=""
      />
    </div>
  );
};

Reason.propTypes = {
  setSuccess: func.isRequired,
};

const Applicants = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const hoverShowTimerRef = useRef(null);
  const hoverHideTimerRef = useRef(null);

  const { id, stage } = useParams();

  const [open, setOpen] = useState(false);

  const { user } = useSelector(({ profile }) => profile);

  const [openMain, setOpenMain] = useState(false);

  const [success, setSuccess] = useState(false);

  const [loading, setLoading] = useState(false);

  const [filePreview, setFilePreview] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const [value, setValue] = useState(0);

  // ─── Tier 3 only: single placement-fee agreement checkbox ───────────────────

  const [placementFeeAgreement, setPlacementFeeAgreement] = useState(false);

  const [imageUpload, setImageUpload] = useState(null);

  const [currentApplicant, setCurrentApplicant] = useState();

  const [reason, setReason] = useState("");

  const [message, setMessage] = useState("");

  const [salary, setSalary] = useState("");

  const [salaryPlacement, setSalaryPlacement] = useState(0);

  const [openPlacement, setOpenPlacement] = useState(false);

  const [hiring, setHiring] = useState(false);

  const [movingApplicant, setMovingApplicant] = useState(false);

  const [decliningApplication, setDecliningApplication] = useState(false);

  const [submittingHiring, setSubmittingHiring] = useState(false);

  const [openDeclineConfirm, setOpenDeclineConfirm] = useState(false);

  const [openHireConfirm, setOpenHireConfirm] = useState(false);

  const [savingNote, setSavingNote] = useState(false);

  const [applicantNotes, setApplicantNotes] = useState({});

  const [openDocumentViewer, setOpenDocumentViewer] = useState(false);

  const [currentDocument, setCurrentDocument] = useState({ url: "", name: "" });

  const [hoverPreviewApplicant, setHoverPreviewApplicant] = useState(null);
  const [hoverAnchorEl, setHoverAnchorEl] = useState(null);

  const [openJobDetailsModal, setOpenJobDetailsModal] = useState(false);

  // Pagination state

  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const [totalCount, setTotalCount] = useState(0);

  const [perPage, setPerPage] = useState(10);

  console.log("Current Applicant", currentApplicant);

  const [experiences, setExperiences] = useState([]);

  const [checkIn, setCheckIn] = useState();

  const [hiringPost, setHiringPost] = useState({
    user_id: "",

    applicant_name: "",

    applicant_id: "",

    job_id: "",

    organisation: "",

    position: "",

    salaryID: "",

    salary_approved: "yes",

    contract_url: "",

    placement_fee: "",
  });

  const { applicants, updated } = useSelector(({ insight }) => insight);

  const { job } = useSelector((state) => state.job);

  const [idProfile, setIdProfile] = useState("");

  const [activeTab, setActiveTab] = useState("all");

  const [openDialog, setOpenDialogue] = useState(false);

  const [agreedSalary, setAgreedSalary] = useState("");

  const [showNotesInput, setShowNotesInput] = useState(false);

  const [note, setNote] = useState("");

  const [openNotesModal, setOpenNotesModal] = useState(false);

  const [openNotesViewModal, setOpenNotesViewModal] = useState(false);

  const [currentNote, setCurrentNote] = useState("");

  const [openRecommendationModal, setOpenRecommendationModal] = useState(false);

  const [currentRecommendation, setCurrentRecommendation] = useState("");

  // Bulk move state

  const [selectedCandidates, setSelectedCandidates] = useState([]);

  const [selectedStage, setSelectedStage] = useState("");

  const [bulkMoveReason, setBulkMoveReason] = useState("");

  const [bulkMoving, setBulkMoving] = useState(false);

  const [selectAll, setSelectAll] = useState(false);

  const [openBulkMoveModal, setOpenBulkMoveModal] = useState(false);

  const [bulkSearch, setBulkSearch] = useState("");

  const [bulkSearchInput, setBulkSearchInput] = useState("");

  // Salary confirmation status map: { applicant_id: { status, salary_responded_at } }
  const [salaryStatuses, setSalaryStatuses] = useState({});

  // Filter state

  const [matchScoreFilter, setMatchScoreFilter] = useState("");

  const [stageFilter, setStageFilter] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const [search, setSearch] = useState("");

  const jobTier = Number(job?.job_tier);

  // ─── Tier 3 modal submit gate:

  //     requires the placement-fee checkbox + a contract file upload

  const isSubmitDisabled =
    !placementFeeAgreement || !imageUpload || !hiringPost.salaryID;

  // Debounce search input (300ms) before triggering API fetch

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchInput);

      setCurrentPage(1);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    if (stage === "hired" && id) {
      httpRequest("get", `/jobs/${id}/salary-statuses`)
        .then(({ data }) => {
          if (data?.status && data?.data) {
            setSalaryStatuses(data.data);
          }
        })
        .catch(() => {});
    }
  }, [stage, id]);

  const getActiveFilters = () => {
    const filters = {};

    if (search && search.trim()) filters.search = search.trim();

    if (matchScoreFilter) {
      if (matchScoreFilter === "desc") {
        filters.sort_by = "match_score_desc";
      } else if (matchScoreFilter === "asc") {
        filters.sort_by = "match_score_asc";
      }
    }

    return filters;
  };

  const handleOpenNotesView = (applicant) => {
    setCurrentApplicant(applicant);

    const storedNote =
      applicantNotes[applicant.applicant_id] ?? applicant.recruiter_notes ?? "";

    setCurrentNote(storedNote);

    setOpenNotesViewModal(true);
  };

  const handleCloseNotesView = () => {
    setOpenNotesViewModal(false);

    setCurrentNote("");
  };

  const handleOpenNotesEdit = () => {
    setNote(currentNote);

    setOpenNotesViewModal(false);

    setOpenNotesModal(true);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleGetExperience = async (idProfile) => {
    try {
      const response = await getSingleExperienceAction(idProfile, dispatch);

      if (response && response.payload) {
        setExperiences(response.payload);
      } else {
        setExperiences([]);
      }
    } catch (error) {
      setExperiences([]);
    }
  };

  useEffect(() => {
    if (idProfile) {
      Promise.all([
        getOtherUserAction(dispatch, idProfile),

        logProfileVisits(dispatch, idProfile),
      ]);
    }
  }, [dispatch, idProfile]);

  const handleOpenProfile = async (applicantId) => {
    try {
      clearOtherUserAction(dispatch); // Clear stale profile before loading new one

      setOpenDialogue(true);

      setIdProfile(applicantId);

      await handleGetExperience(applicantId);

      const applicant = jobApplicants.find(
        (a) => a.applicant_id === applicantId,
      );

      setCurrentApplicant(applicant);

      const noteResponse = await getApplicantNote(dispatch, applicantId, id);

      if (noteResponse && noteResponse.data) {
        setNote(noteResponse.data.note || "");
      } else {
        setNote("");
      }
    } catch (error) {
      console.error(error);

      setNote("");
    }
  };

  const handleCloseProfile = () => {
    setOpenDialogue(false);
  };

  useEffect(() => {
    getJob(dispatch, id);
  }, [dispatch, id]);

  const handleFileChange = async (e, applicant, job) => {
    const file = e.target.files[0];

    const reader = new FileReader();

    reader.onload = () => {
      setFilePreview(reader.result);
    };

    reader.readAsDataURL(file);

    if (file) {
      Promise.resolve(
        uploadFile(
          file,

          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload",
        ),
      )

        .then(({ data, success }) => {
          if (success) {
            setImageUpload(data);
          } else {
            cogoToast.error("Unsuccessful document upload", {
              hideAfter: 4,

              position: "top-center",
            });
          }
        })

        .finally(() => {});
    }
  };

  const handleSalaryApprovalChange = (e) => {
    const value = e.target.value;

    setHiringPost((prevState) => ({
      ...prevState,

      salary_approved: value,
    }));
  };

  const showSalaryInput = hiringPost.salary_approved === "yes";

  const handleHiringDetails = async (
    applicant_name,

    applicant_id,

    jobId,

    jobCompany,

    jobRole,
  ) => {
    setSubmittingHiring(true);

    try {
      const userDataString =
        sessionStorage.getItem("userData") || localStorage.getItem("userData");

      if (!userDataString) {
        cogoToast.error("User data not found. Please login again.", {
          hideAfter: 4,

          position: "top-center",
        });

        setSubmittingHiring(false);

        return;
      }

      const userData = JSON.parse(userDataString);

      const profileId = Number(userData.id);

      const placement_fee = hiringPost.salaryID * 0.1;

      if (!hiringPost.salaryID && hiringPost.salary_approved === "yes") {
        cogoToast.error("Please enter a valid salary", {
          hideAfter: 4,

          position: "top-center",
        });

        setSubmittingHiring(false);

        return;
      }

      // Check Tier 3 payment before proceeding

      if (jobTier === 3) {
        try {
          const paymentCheckResponse = await httpRequest(
            "post",

            "/jobs/check_tier3_payment",

            { job_id: Number(jobId) },
          );

          const paymentCheckData = paymentCheckResponse.data;

          if (!paymentCheckData.status) {
            cogoToast.error(
              paymentCheckData.message || "Failed to verify payment status",
              {
                hideAfter: 4,

                position: "top-center",
              },
            );

            setSubmittingHiring(false);

            return;
          }

          if (
            paymentCheckData.payment_required &&
            !paymentCheckData.payment_made
          ) {
            cogoToast.error(
              "Initial payment required for Tier 3 job before hiring. Please complete the payment first.",

              {
                hideAfter: 5,

                position: "top-center",
              },
            );

            setSubmittingHiring(false);

            // Optionally redirect to payment page

            // history.push(`/payment/tier3/${jobId}`);

            return;
          }
        } catch (error) {
          console.error("Error checking Tier 3 payment:", error);

          cogoToast.error(
            "Failed to verify payment status. Please try again.",
            {
              hideAfter: 4,

              position: "top-center",
            },
          );

          setSubmittingHiring(false);

          return;
        }
      }

      const data = {
        user_id: profileId,

        applicant_name: applicant_name,

        applicant_id: Number(applicant_id),

        job_id: Number(jobId),

        organisation: job?.company_name,

        position: jobRole,

        salary: String(hiringPost.salaryID),

        salary_approved: hiringPost.salary_approved,

        contract_url: imageUpload,

        placement_fee: placement_fee,
      };

      await postHiring(dispatch, data);

      handleCleanup();

      if (jobTier !== 3) {
        setSalaryPlacement(placement_fee);

        setOpenPlacement(true);
      }

      const applStage = (() => {
        switch (stage) {
          case "consider":
            return "1";

          case "test":
            return "2";

          case "interview":
            return "3";

          case "hired":
            return "4";

          case "regret":
            return "5";

          default:
            return "*";
        }
      })();

      await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        getActiveFilters(),
      );

      // Show specific toast for Tier 3 hiring (credit or successful completion)

      if (jobTier === 3) {
        cogoToast.success(
          "Hiring completed. Salary adjustment applied - check wallet for any credits.",
          {
            hideAfter: 5,

            position: "top-center",
          },
        );
      } else {
        // Show generic success for non-Tier 3

        cogoToast.success("Hiring details submitted successfully", {
          hideAfter: 4,

          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error in handleHiringDetails:", error);

      const errorMessage =
        error?.response?.data?.message || "Failed to submit hiring details";

      const errorData = error?.response?.data?.data;

      // Tier 3 hard-block: outstanding final invoice must be paid before hiring can proceed

      if (
        errorMessage

          .toLowerCase()

          .includes("outstanding tier 3 placement fee balance")
      ) {
        const amountDue = errorData?.amount_due;

        cogoToast.error(
          `${errorMessage}${amountDue ? ` Amount due: ${amountDue}` : ""} Redirecting to wallet...`,

          { hideAfter: 7, position: "top-center" },
        );

        history.push("/wallet/add");

        return;
      }

      // Check if it's a wallet balance error

      if (errorMessage.includes("Insufficient wallet balance")) {
        cogoToast.error(
          errorMessage + " Please go to your wallet to add funds.",

          { hideAfter: 7, position: "top-center" },
        );
      } else {
        cogoToast.error(
          errorMessage,

          { hideAfter: 4, position: "top-center" },
        );
      }
    } finally {
      setSubmittingHiring(false);
    }
  };

  const handleCleanup = () => {
    setOpen(false);

    setOpenMain(false);

    setOpenModal(false);

    setHiringPost((prevState) => ({
      ...prevState,

      salaryID: "",

      salary_approved: "",
    }));

    // Reset tier-3 checkbox

    setPlacementFeeAgreement(false);

    setImageUpload(null);
  };

  const handleHire = () => {
    const hire = async () => {
      const data = {
        job_id: parseInt(id, 10),

        applicant_id: parseInt(currentApplicant.applicant_id),

        message,

        salary: Number(salary) || Number(hiringPost.salary_approved),
      };

      setHiring(true);

      await hireApplicant(dispatch, data);

      if (updated) {
        handleClose();
      }

      setHiring(false);
    };

    hire();
  };

  const handleAgreedSalaryChange = (e) => {
    if (e.target) {
      setSalary(e.target.value);

      setHiringPost((prevState) => ({
        ...prevState,

        salary: e.target.value,
      }));
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    // Reset tier-3 checkbox when modal closes

    setPlacementFeeAgreement(false);

    setImageUpload(null);
  };

  /**

   * Called when the recruiter clicks "Hire Applicant".

   *

   * Tier 1 → hire directly (no modal)

   * Tier 2 → hire directly (no modal, pay-per-view handled elsewhere)

   * Tier 3 → open the Hiring Questionnaire modal

   */

  const handleOpenModal = (applicant) => {
    setCurrentApplicant(applicant);

    setOpen(false);

    if (jobTier === 3) {
      // Show the questionnaire modal only for tier 3

      setPlacementFeeAgreement(false);

      setImageUpload(null);

      setOpenModal(true);

      setOpenMain(true);
    } else {
      // Tier 1 & 2 — show confirmation modal before hiring

      setOpenHireConfirm(true);
    }
  };

  const handleCloseHireConfirm = () => {
    setOpenHireConfirm(false);
  };

  const handleConfirmHire = async () => {
    if (!currentApplicant) return;

    setHiring(true);

    try {
      const data = {
        job_id: parseInt(id, 10),

        applicant_id: parseInt(currentApplicant.applicant_id),

        message,
      };

      await hireApplicant(dispatch, data);

      const applStage = (() => {
        switch (stage) {
          case "consider":
            return "1";

          case "test":
            return "2";

          case "interview":
            return "3";

          case "hired":
            return "4";

          case "regret":
            return "5";

          default:
            return "*";
        }
      })();

      await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        getActiveFilters(),
      );

      setOpenHireConfirm(false);

      handleClose();

      cogoToast.success("Applicant hired successfully", {
        hideAfter: 3,

        position: "top-center",
      });
    } catch (error) {
      console.error("Error hiring applicant:", error);

      cogoToast.error(
        error?.response?.data?.message || "Failed to hire applicant",

        { hideAfter: 3, position: "top-center" },
      );
    } finally {
      setHiring(false);
    }
  };

  const handleSetMessage = (message) => {
    setMessage(message);
  };

  const handleClosePlacement = () => {
    setOpenPlacement(false);
  };

  useEffect(() => {
    let applStage;

    switch (stage) {
      case "consider":
        applStage = "1";
        break;

      case "test":
        applStage = "2";
        break;

      case "interview":
        applStage = "3";
        break;

      case "hired":
        applStage = "4";
        break;

      case "regret":
        applStage = "5";
        break;

      default:
        applStage = "*";
        break;
    }

    const getApplicants = async () => {
      setLoading(true);

      const filters = getActiveFilters();

      const response = await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        filters,
      );

      if (response && response.payload) {
        setTotalPages(response.payload.total_pages || 1);

        setTotalCount(response.payload.total_count || 0);

        setPerPage(response.payload.per_page || 10);
      }

      setLoading(false);
    };

    getApplicants();
  }, [job, stage, currentPage, perPage, search, matchScoreFilter, stageFilter]);

  // Reset to page 1 when stage changes

  useEffect(() => {
    setCurrentPage(1);
  }, [stage]);

  useEffect(() => {
    getJob(dispatch, id);
  }, [dispatch, id]);

  const jobApplicants = applicants ? applicants["Applicants"] : [];

  useEffect(() => {
    if (!jobApplicants || jobApplicants.length === 0) {
      setApplicantNotes({});

      return;
    }

    let cancelled = false;

    const fetchNotesForApplicants = async () => {
      try {
        const noteEntries = await Promise.all(
          jobApplicants.map(async (applicant) => {
            try {
              const response = await getApplicantNote(
                dispatch,

                applicant.applicant_id,

                id,
              );

              return [
                applicant.applicant_id,

                response?.data?.note ? response.data.note : "",
              ];
            } catch (error) {
              return [applicant.applicant_id, ""];
            }
          }),
        );

        if (!cancelled) {
          const notesMap = noteEntries.reduce(
            (acc, [applicantId, noteValue]) => {
              acc[applicantId] = noteValue;

              return acc;
            },

            {},
          );

          setApplicantNotes(notesMap);
        }
      } catch (error) {
        console.error("Error fetching applicant notes:", error);
      }
    };

    fetchNotesForApplicants();

    return () => {
      cancelled = true;
    };
  }, [dispatch, id, jobApplicants]);

  const handleOpen = (applicant) => {
    setCurrentApplicant(applicant);

    setOpenModal(false);

    setOpen(true);

    const currentStage = parseInt(applicant.applicationStage) || 0;

    setValue(currentStage);
  };

  const isStageDisabled = (stageValue) => {
    const currentStage = parseInt(currentApplicant?.applicationStage) || 0;

    return stageValue < currentStage;
  };

  const getStageLabel = (stage) => {
    const stageNum = parseInt(stage) || 0;

    switch (stageNum) {
      case 1:
        return "Consider";

      case 2:
        return "Test";

      case 3:
        return "Interview";

      case 4:
        return "Hired";

      case 5:

      case 6:
        return "Regret";

      default:
        return "Unknown";
    }
  };

  const hasMovedToStage = (stageValue) => {
    const stageNum = parseInt(stageValue, 10);

    return !Number.isNaN(stageNum) && stageNum > 0;
  };

  const getStageColor = (stage) => {
    const stageNum = parseInt(stage) || 0;

    switch (stageNum) {
      case 1:
        return "#17a2b8";

      case 2:
        return "#ffc107";

      case 3:
        return "#007bff";

      case 4:
        return "#28a745";

      case 5:

      case 6:
        return "#dc3545";

      default:
        return "#6c757d";
    }
  };

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value);

    if (!isStageDisabled(newValue)) {
      setValue(newValue);
    }
  };

  const handleViewDocument = (url, name) => {
    setCurrentDocument({ url, name });

    setOpenDocumentViewer(true);
  };

  const handleCloseDocumentViewer = () => {
    setOpenDocumentViewer(false);

    setCurrentDocument({ url: "", name: "" });
  };

  const clearHoverPreview = useCallback(() => {
    if (hoverShowTimerRef.current) {
      clearTimeout(hoverShowTimerRef.current);
      hoverShowTimerRef.current = null;
    }
    if (hoverHideTimerRef.current) {
      clearTimeout(hoverHideTimerRef.current);
      hoverHideTimerRef.current = null;
    }
    setHoverPreviewApplicant(null);
    setHoverAnchorEl(null);
  }, []);

  const scheduleHideHoverPreview = useCallback(() => {
    if (hoverHideTimerRef.current) {
      clearTimeout(hoverHideTimerRef.current);
    }
    hoverHideTimerRef.current = setTimeout(() => {
      clearHoverPreview();
    }, 200);
  }, [clearHoverPreview]);

  const handleRowMouseEnter = useCallback(
    (event, applicant) => {
      if (isMobileView) {
        return;
      }

      if (event.target.closest && event.target.closest(".applicant-row-no-preview")) {
        return;
      }

      const rowEl = event.currentTarget;

      if (hoverHideTimerRef.current) {
        clearTimeout(hoverHideTimerRef.current);
        hoverHideTimerRef.current = null;
      }
      if (hoverShowTimerRef.current) {
        clearTimeout(hoverShowTimerRef.current);
      }

      hoverShowTimerRef.current = setTimeout(() => {
        setHoverPreviewApplicant(applicant);
        setHoverAnchorEl(rowEl);
      }, 300);
    },
    [isMobileView],
  );

  const handleRowMouseLeave = useCallback(() => {
    if (hoverShowTimerRef.current) {
      clearTimeout(hoverShowTimerRef.current);
      hoverShowTimerRef.current = null;
    }
    scheduleHideHoverPreview();
  }, [scheduleHideHoverPreview]);

  const handlePreviewMouseEnter = useCallback(() => {
    if (hoverHideTimerRef.current) {
      clearTimeout(hoverHideTimerRef.current);
      hoverHideTimerRef.current = null;
    }
  }, []);

  const handleOpenFullResume = useCallback(
    (url, name) => {
      clearHoverPreview();
      handleViewDocument(url, name);
    },
    [clearHoverPreview],
  );

  useEffect(() => () => clearHoverPreview(), [clearHoverPreview]);

  const handleHiringPost = (event) => {
    const { name, value } = event.target;

    setHiringPost((prevState) => ({
      ...prevState,

      [name]: value,
    }));
  };

  const handleReason = (reason) => {
    setReason(reason);
  };

  const handleOpenMain = (applicant) => {
    setCurrentApplicant(applicant);

    setOpenMain(true);
  };

  const handleClose = () => {
    clearUpdated(dispatch);

    setSuccess(false);

    setOpen(false);

    setOpenMain(false);

    setOpenModal(false);

    setReason("");

    setMessage("");
  };

  const handleSubmit = async () => {
    setMovingApplicant(true);

    try {
      const updateApplData = {
        job_id: parseInt(id, 10),

        stage_code: parseInt(value, 10),

        applicant_id: parseInt(currentApplicant.applicant_id, 10),

        reason: message,
      };

      await updateApplication(dispatch, updateApplData);

      const applStage = (() => {
        switch (stage) {
          case "consider":
            return "1";

          case "test":
            return "2";

          case "interview":
            return "3";

          case "hired":
            return "4";

          case "regret":
            return "5";

          default:
            return "*";
        }
      })();

      await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        getActiveFilters(),
      );

      handleClose();

      cogoToast.success("Applicant moved successfully", {
        hideAfter: 3,

        position: "top-center",
      });
    } catch (error) {
      console.error("Error moving applicant:", error);

      cogoToast.error("Failed to move applicant", {
        hideAfter: 3,

        position: "top-center",
      });
    } finally {
      setMovingApplicant(false);
    }
  };

  const handleOpenDeclineConfirm = () => {
    setOpenDeclineConfirm(true);
  };

  const handleCloseDeclineConfirm = () => {
    setOpenDeclineConfirm(false);
  };

  const rejectApplication = async () => {
    setDecliningApplication(true);

    try {
      await declineApplication(dispatch, id, currentApplicant.applicant_id);

      cogoToast.success("Application declined successfully", {
        hideAfter: 3,

        position: "top-center",
      });

      setOpenDeclineConfirm(false);

      handleClose();

      const applStage = (() => {
        switch (stage) {
          case "consider":
            return "1";

          case "test":
            return "2";

          case "interview":
            return "3";

          case "hired":
            return "4";

          case "regret":
            return "5";

          default:
            return "*";
        }
      })();

      await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        getActiveFilters(),
      );
    } catch (error) {
      console.error("Error declining application:", error);

      setOpenDeclineConfirm(false);

      handleClose();

      cogoToast.error("Failed to decline application", {
        hideAfter: 3,

        position: "top-center",
      });
    } finally {
      setDecliningApplication(false);
    }
  };

  const handleSaveNote = async () => {
    setSavingNote(true);

    try {
      await updateApplicantNote(
        dispatch,

        currentApplicant.applicant_id,

        note,

        id,
      );

      setOpenNotesModal(false);

      setCurrentApplicant((prev) => ({ ...prev, recruiter_notes: note }));

      setApplicantNotes((prev) => ({
        ...prev,

        [currentApplicant.applicant_id]: note,
      }));

      cogoToast.success("Note saved successfully", {
        hideAfter: 3,

        position: "top-center",
      });

      const applStage =
        stage === undefined
          ? "*"
          : (() => {
              switch (stage) {
                case "consider":
                  return "1";

                case "test":
                  return "2";

                case "interview":
                  return "3";

                case "hired":
                  return "4";

                case "regret":
                  return "5";

                default:
                  return "*";
              }
            })();

      await getJobApplicants(
        dispatch,

        id,

        applStage,

        currentPage,

        perPage,

        getActiveFilters(),
      );
    } catch (error) {
      console.error("Error saving note:", error);

      cogoToast.error("Failed to save note", {
        hideAfter: 3,

        position: "top-center",
      });
    } finally {
      setSavingNote(false);
    }
  };

  // ─── Bulk move handlers ────────────────────────────────────────────────────

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCandidates([]);
    } else {
      const allIds = jobApplicants.map((app) => app.applicant_id);

      setSelectedCandidates(allIds);
    }

    setSelectAll(!selectAll);
  };

  const handleSelectCandidate = (e, applicantId) => {
    e.stopPropagation();

    if (selectedCandidates.includes(applicantId)) {
      setSelectedCandidates(
        selectedCandidates.filter((id) => id !== applicantId),
      );

      setSelectAll(false);
    } else {
      setSelectedCandidates([...selectedCandidates, applicantId]);
    }
  };

  const handleOpenBulkMoveModal = () => {
    if (selectedCandidates.length === 0) {
      cogoToast.error("Please select at least one candidate", {
        hideAfter: 3,

        position: "top-center",
      });

      return;
    }

    setOpenBulkMoveModal(true);
  };

  const handleCloseBulkMoveModal = () => {
    setOpenBulkMoveModal(false);

    setSelectedStage("");

    setBulkMoveReason("");
  };

  const getMinimumAllowedStage = () => {
    if (!jobApplicants || selectedCandidates.length === 0) return 0;

    let maxStage = 0;

    selectedCandidates.forEach((candidateId) => {
      const applicant = jobApplicants.find(
        (app) => app.applicant_id === candidateId,
      );

      if (applicant && applicant.applicationStage !== undefined) {
        const currentStage = parseInt(applicant.applicationStage);

        if (currentStage > maxStage) maxStage = currentStage;
      }
    });

    return maxStage;
  };

  const isStageDisabledForBulkMove = (stageValue) => {
    const minAllowedStage = getMinimumAllowedStage();

    const stageNum = parseInt(stageValue);

    if (stageNum === 5) return false;

    return stageNum < minAllowedStage;
  };

  const handleBulkMove = async () => {
    if (!selectedStage) {
      cogoToast.error("Please select a stage", {
        hideAfter: 3,

        position: "top-center",
      });

      return;
    }

    setBulkMoving(true);

    try {
      const result = await bulkMoveCandidates(
        id,

        selectedCandidates,

        parseInt(selectedStage),

        bulkMoveReason || null,
      );

      setBulkMoving(false);

      if (
        result &&
        (result.status === true || result.error === false) &&
        result.data
      ) {
        const { moved, failed } = result.data;

        if (moved && moved.length > 0) {
          const applStage = (() => {
            switch (stage) {
              case "consider":
                return "1";

              case "test":
                return "2";

              case "interview":
                return "3";

              case "hired":
                return "4";

              case "regret":
                return "5";

              default:
                return "*";
            }
          })();

          await getJobApplicants(
            dispatch,

            id,

            applStage,

            currentPage,

            perPage,

            getActiveFilters(),
          );

          cogoToast.success(
            `Successfully moved ${moved.length} candidate${moved.length > 1 ? "s" : ""}!`,

            { hideAfter: 3, position: "top-center" },
          );
        }

        if (failed && failed.length > 0) {
          cogoToast.warning(
            `${failed.length} candidate${failed.length > 1 ? "s" : ""} failed to move`,

            { hideAfter: 3, position: "top-center" },
          );
        }

        setOpenBulkMoveModal(false);

        setSelectedCandidates([]);

        setSelectAll(false);

        setSelectedStage("");

        setBulkMoveReason("");
      }
    } catch (error) {
      console.error("Bulk move error:", error);

      setBulkMoving(false);

      cogoToast.error("An error occurred while moving candidates.", {
        hideAfter: 3,

        position: "top-center",
      });
    }
  };

  // ──────────────────────────────────────────────────────────────────────────

  return (
    <div className="position-relative w-100">
      {hiring && (
        <div
          style={{
            position: "fixed",

            inset: 0,

            zIndex: 9999,

            backgroundColor: "rgba(255, 255, 255, 0.75)",

            backdropFilter: "blur(3px)",

            display: "flex",

            flexDirection: "column",

            alignItems: "center",

            justifyContent: "center",

            gap: "16px",
          }}
        >
          {/* Spinner */}

          <div
            style={{
              width: "52px",

              height: "52px",

              borderRadius: "50%",

              border: "4px solid #e0e0e0",

              borderTopColor: "#3A6ED4",

              animation: "wb-spin 0.75s linear infinite",
            }}
          />

          {/* Label */}

          <p
            style={{
              margin: 0,

              fontSize: "15px",

              fontWeight: 600,

              color: "#3A6ED4",

              letterSpacing: "0.3px",
            }}
          >
            Processing hire…
          </p>

          {/* Keyframe injected once via a <style> tag */}

          <style>{`

      @keyframes wb-spin {

        to { transform: rotate(360deg); }

      }

    `}</style>
        </div>
      )}

      {/* Job Title and Location Header */}
      {job && (
        <div
          style={{
            marginBottom: "20px",
            padding: "16px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
          }}
        >
          <h2
            onClick={() => setOpenJobDetailsModal(true)}
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 600,
              color: "#3A6ED4",
              marginBottom: "8px",
              cursor: "pointer",
              textDecoration: "none",
              transition: "color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
            onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
          >
            {job?.role_title}
          </h2>
          {job?.location && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                color: "#6c757d",
                fontSize: "14px",
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{job?.location}</span>
            </div>
          )}
        </div>
      )}
      <div className="d-flex justify-content-between filters mb-4">
        {job?.isToRefTimeLineOrToHireRecruter !== "2" && (
          <>
            <button
              onClick={() => {
                history.push(`/insights/jobs/applicants/${id}`);

                handleTabClick("all");
              }}
              className={activeTab === "all" ? "active" : ""}
            >
              All
            </button>

            <button
              onClick={() => {
                history.push(`/insights/jobs/applicants/${id}/consider`);

                handleTabClick("consider");
              }}
              className={activeTab === "consider" ? "active" : ""}
            >
              Consider
            </button>

            <button
              onClick={() => {
                history.push(`/insights/jobs/applicants/${id}/test`);

                handleTabClick("test");
              }}
              className={activeTab === "test" ? "active" : ""}
            >
              Test
            </button>

            <button
              onClick={() => {
                history.push(`/insights/jobs/applicants/${id}/interview`);

                handleTabClick("interview");
              }}
              className={activeTab === "interview" ? "active" : ""}
            >
              Interview
            </button>

            <button
              onClick={() => {
                history.push(`/insights/jobs/applicants/${id}/regret`);

                handleTabClick("regret");
              }}
              className={activeTab === "regret" ? "active" : ""}
            >
              Regret
            </button>
          </>
        )}
      </div>

      {/* Filter Bar */}

      <div
        style={{
          display: "flex",

          flexDirection: "column",

          gap: "12px",

          marginBottom: "16px",

          padding: "12px 16px",

          border: "1px solid #e0e0e0",

          borderRadius: "8px",

          backgroundColor: "#f8f9fa",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CustomSearchInput
            handleChange={(e) => setSearchInput(e.target.value)}
            value={searchInput}
            InputProps={{
              placeholder: "Search applicants...",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",

            alignItems: "center",

            justifyContent: "space-between",
          }}
        >
          {job?.job_tier !== "1" && (
            <div style={{ position: "relative", display: "inline-block" }}>
              <select
                value={matchScoreFilter}
                onChange={(e) => {
                  setMatchScoreFilter(e.target.value);

                  setCurrentPage(1);
                }}
                style={{
                  minWidth: "170px",

                  borderRadius: "6px",

                  border: "1px solid #ccc",

                  padding: "10px 12px",

                  fontSize: "14px",

                  cursor: "pointer",

                  backgroundColor: "#fff",

                  outline: "none",

                  appearance: "none",

                  WebkitAppearance: "none",

                  MozAppearance: "none",
                }}
              >
                <option value="">All Match Scores</option>

                <option value="desc">Highest to Lowest</option>

                <option value="asc">Lowest to Highest</option>
              </select>

              <svg
                style={{
                  position: "absolute",

                  right: "10px",

                  top: "50%",

                  transform: "translateY(-50%)",

                  pointerEvents: "none",

                  width: "16px",

                  height: "16px",

                  fill: "none",

                  stroke: "#666",

                  strokeWidth: "2",
                }}
                viewBox="0 0 24 24"
              >
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </div>
          )}

          {(matchScoreFilter || stageFilter || search || searchInput) && (
            <button
              onClick={() => {
                setMatchScoreFilter("");

                setSearchInput("");

                setSearch("");

                setCurrentPage(1);
              }}
              style={{
                backgroundColor: "#e3e3e3",

                color: "#333",

                borderRadius: "6px",

                padding: "10px 16px",

                fontSize: "13px",

                border: "none",

                cursor: "pointer",
              }}
            >
              Clear Filters
            </button>
          )}
        </div>
      </div>

      {loading && <SectionLoader />}

      {!loading && !jobApplicants && (
        <div className="d-flex align-items-center cursor-pointer justify-content-center mb-3">
          <p className="text-center">No applicants</p>
        </div>
      )}

      {/* Bulk Move Controls */}

      {!loading && jobApplicants && jobApplicants.length > 0 && (
        <div className="mb-4 p-3 border rounded bg-light">
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                className="mr-2"
                style={{
                  width: "18px",

                  height: "18px",

                  cursor: "pointer",

                  accentColor: "#3A6ED4",
                }}
              />

              <label className="mb-0 font-weight-bold">
                Select All ({selectedCandidates.length} selected)
              </label>
            </div>

            {selectedCandidates.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenBulkMoveModal}
              >
                Move {selectedCandidates.length} Candidate
                {selectedCandidates.length > 1 ? "s" : ""}
              </Button>
            )}
          </div>
        </div>
      )}

      {!loading &&
        jobApplicants &&
        jobApplicants.length > 0 &&
        jobApplicants.map((applicant) => {
          const timingInfo = getApplicationTimingInfo(applicant.date_created);

          const shouldShowStageBadge =
            !stage && hasMovedToStage(applicant.applicationStage);

          const storedNote =
            applicantNotes[applicant.applicant_id] ??
            applicant.recruiter_notes ??
            "";

          const hasNotes =
            typeof storedNote === "string" && storedNote.trim() !== "";

          const isSelected = selectedCandidates.includes(
            applicant.applicant_id,
          );

          return (
            <div
              key={applicant.id}
              onClick={() => handleOpen(applicant)}
              onMouseEnter={(event) => handleRowMouseEnter(event, applicant)}
              onMouseLeave={handleRowMouseLeave}
              className={`d-flex align-items-center cursor-pointer justify-content-between mb-3 p-2 rounded applicant-row ${
                isSelected ? "bg-light border border-primary" : ""
              }`}
            >
              <span className="d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) =>
                    handleSelectCandidate(e, applicant.applicant_id)
                  }
                  onClick={(e) => e.stopPropagation()}
                  className="mr-3 applicant-row-no-preview"
                  style={{
                    width: "18px",

                    height: "18px",

                    cursor: "pointer",

                    accentColor: "#3A6ED4",
                  }}
                />

                <img width="50" src={applicant.image_url} alt="avatar" />

                <span className="d-flex flex-column ml-3">
                  <div>
                    <h6 className="mb-0">
                      {applicant.first_name} {applicant.last_name}
                    </h6>
                    <div
                      className="d-flex align-items-center mt-1"
                      style={{ flexWrap: "wrap", gap: "4px" }}
                    >
                      {timingInfo && (
                        <span
                          className="px-2 py-1 small-text rounded"
                          style={{
                            backgroundColor: timingInfo.bgColor,
                            color: "#fff",
                            fontSize: "0.7rem",
                            fontWeight: "bold",
                            textTransform: timingInfo.uppercase
                              ? "uppercase"
                              : "none",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {timingInfo.label}
                        </span>
                      )}
                      {shouldShowStageBadge && (
                        <span
                          className="px-2 py-1 small-text rounded"
                          style={{
                            backgroundColor: getStageColor(
                              applicant.applicationStage,
                            ),
                            color: "#fff",
                            fontSize: "0.7rem",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getStageLabel(applicant.applicationStage)}
                        </span>
                      )}
                      {(() => {
                        const salaryInfo =
                          salaryStatuses[applicant.applicant_id];
                        if (
                          !salaryInfo ||
                          parseInt(applicant.applicationStage) !== 4
                        )
                          return null;
                        const statusMap = {
                          pending: { label: "Salary: Pending", bg: "#FF9800" },
                          approved: {
                            label: "Salary: Verified",
                            bg: "#4CAF50",
                          },
                          deny: { label: "Salary: Disputed", bg: "#f44336" },
                          paid: { label: "Salary: Paid", bg: "#2196F3" },
                        };
                        const conf = statusMap[salaryInfo.status] || {
                          label: `Salary: ${salaryInfo.status}`,
                          bg: "#9E9E9E",
                        };
                        return (
                          <span
                            className="px-2 py-1 small-text rounded"
                            style={{
                              backgroundColor: conf.bg,
                              color: "#fff",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                            title={
                              salaryInfo.salary_responded_at
                                ? `Responded: ${salaryInfo.salary_responded_at}`
                                : "Awaiting response"
                            }
                          >
                            {conf.label}
                          </span>
                        );
                      })()}
                      {hasNotes && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenNotesView(applicant);
                          }}
                          title="View Notes"
                          style={{
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            color: "#3a6ed4",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                          </svg>
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="co-gray small-text">
                    @{applicant.username}
                  </span>
                  {job?.job_tier !== "1" && (
                    <>
                      {applicant.skills_match !== undefined &&
                        applicant.skills_match !== null && (
                          <span className="co-gray small-text">
                            Match Score:{" "}
                            {typeof applicant.skills_match === "number"
                              ? `${Math.round(applicant.skills_match)}%`
                              : applicant.skills_match}
                          </span>
                        )}
                      {applicant.match_score_recommendation && (
                        <span className="co-gray small-text mt-1">
                          <span
                            className="text-primary cursor-pointer"
                            style={{ textDecoration: "underline" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentRecommendation(
                                applicant.match_score_recommendation,
                              );
                              setOpenRecommendationModal(true);
                            }}
                          >
                            View AI Recommendation
                          </span>
                        </span>
                      )}
                    </>
                  )}
                </span>
              </span>

              <span
                className="applicant-row-no-preview"
                onMouseEnter={clearHoverPreview}
              >
                <CustomButton
                  text={
                    job?.isToRefTimeLineOrToHireRecruter === "2"
                      ? "Hire"
                      : "Move"
                  }
                  alt="Move"
                  type="button"
                  backgroundColor="white"
                  borderColor="var(--primary-color)"
                  additionalClass={"px-4"}
                  handleClick={(event) => {
                    event.stopPropagation();
                    handleOpen(applicant);
                  }}
                />
              </span>
            </div>
          );
        })}

      {/* Pagination Controls */}

      {!loading &&
        jobApplicants &&
        jobApplicants.length > 0 &&
        totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4 mb-4 px-3">
            <div className="co-gray small-text">
              Showing {(currentPage - 1) * perPage + 1} -{" "}
              {Math.min(currentPage * perPage, totalCount)} of {totalCount}{" "}
              applicants
            </div>

            <div className="d-flex align-items-center">
              <CustomButton
                text="Previous"
                handleClick={() =>
                  setCurrentPage((prev) => Math.max(1, prev - 1))
                }
                disabled={currentPage === 1 || loading}
                backgroundColor={
                  currentPage === 1 ? "#e0e0e0" : "var(--primary-color)"
                }
                color={currentPage === 1 ? "#999" : "#fff"}
                additionalClass="px-3 py-1 mx-1"
              />

              <span
                className="mx-3 co-gray"
                style={{
                  whiteSpace: "nowrap",

                  minWidth: "80px",

                  textAlign: "center",
                }}
              >
                Page {currentPage} of {totalPages}
              </span>

              <CustomButton
                text="Next"
                handleClick={() =>
                  setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                }
                disabled={currentPage === totalPages || loading}
                backgroundColor={
                  currentPage === totalPages
                    ? "#e0e0e0"
                    : "var(--primary-color)"
                }
                color={currentPage === totalPages ? "#999" : "#fff"}
                additionalClass="px-3 py-1 mx-1"
              />
            </div>
          </div>
        )}

      {/* ── Move / Stage Dialog ─────────────────────────────────────────────── */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            width: "40rem",

            borderRadius: "1rem",

            padding: "0.75rem",
          },
        }}
      >
        {currentApplicant && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between">
              <DialogTitle id="form-dialog-title">
                {!success && (
                  <span className="w-100 d-flex align-items-center">
                    <img
                      width="50"
                      src={currentApplicant.image_url}
                      alt="avatar"
                    />

                    <span className="d-flex flex-column ml-3">
                      <h6 className="mb-0">
                        {currentApplicant.first_name}{" "}
                        {currentApplicant.last_name}
                      </h6>

                      <CustomButton
                        handleClick={() =>
                          handleOpenProfile(currentApplicant.applicant_id)
                        }
                        backgroundColor="#3A6ED4"
                        color="#fff"
                        text="View Profile"
                        additionalClass="mt-2 p-1 small-text"
                      />
                    </span>
                  </span>
                )}
              </DialogTitle>

              <div
                className="close-button"
                style={{ position: "absolute", right: "1rem", top: "1rem" }}
              >
                <IconButton onClick={handleClose}>
                  <svg width="30" height="30" className="rounded-circle">
                    <use href={`${icons}#close`}></use>
                  </svg>
                </IconButton>
              </div>
            </div>
          </div>
        )}

        <DialogContent>
          <RadioGroup
            aria-label="change statue"
            name="status"
            value={value}
            onChange={handleChange}
          >
            {job?.isToRefTimeLineOrToHireRecruter !== "2" && (
              <>
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="Consider"
                  disabled={isStageDisabled(1)}
                />

                {value === 1 && !isStageDisabled(1) && (
                  <Reason
                    key={1}
                    setSuccess={setSuccess}
                    handleReason={handleReason}
                    setMessage={handleSetMessage}
                  />
                )}

                <FormControlLabel
                  value={2}
                  control={<Radio color="primary" />}
                  label="Test"
                  disabled={isStageDisabled(2)}
                />

                {value === 2 && !isStageDisabled(2) && (
                  <Reason
                    key={2}
                    setSuccess={setSuccess}
                    handleReason={handleReason}
                    setMessage={handleSetMessage}
                  />
                )}

                <FormControlLabel
                  value={3}
                  control={<Radio color="primary" />}
                  label="Interview"
                  disabled={isStageDisabled(3)}
                />

                {value === 3 && !isStageDisabled(3) && (
                  <Reason
                    key={3}
                    setSuccess={setSuccess}
                    handleReason={handleReason}
                    setMessage={handleSetMessage}
                  />
                )}
              </>
            )}

            <FormControlLabel
              value={4}
              control={<Radio color="primary" />}
              label="Hire"
              disabled={isStageDisabled(4)}
            />

            {value === 4 && !isStageDisabled(4) && (
              <>
                {job?.isToRefTimeLineOrToHireRecruter === "2" && (
                  <>
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          position: "relative",

                          display: "inline-block",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search candidates to move..."
                          value={bulkSearchInput}
                          onChange={(e) => setBulkSearchInput(e.target.value)}
                          className="form-control"
                          style={{ width: "300px", paddingRight: "40px" }}
                        />

                        <button
                          style={{
                            position: "absolute",

                            right: "5px",

                            top: "50%",

                            transform: "translateY(-50%)",

                            border: "none",

                            background: "none",

                            cursor: "pointer",

                            padding: "5px",
                          }}
                          onClick={() => setBulkSearch(bulkSearchInput)}
                        >
                          🔍
                        </button>
                      </div>

                      <Checkbox
                        checked={selectAll}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            setSelectedCandidates([]);

                            setSelectAll(false);
                          }
                        }}
                        color="primary"
                      />

                      <span>Select All</span>
                    </div>

                    <Reason
                      key={4}
                      setSuccess={setSuccess}
                      handleReason={handleReason}
                      setMessage={handleSetMessage}
                    />
                  </>
                )}
              </>
            )}
          </RadioGroup>
        </DialogContent>

        {!success && (
          <DialogActions className="mt-5">
            <span className="w-100 mr-4">
              <span className="d-flex">
                <CustomButton
                  type="button"
                  handleClick={handleOpenDeclineConfirm}
                  disabled={decliningApplication}
                  backgroundColor="#FF5964"
                  color="#fff"
                  text="Decline Application"
                  additionalClass="mx-3 mt-2"
                  loading={decliningApplication}
                />

                {value !== 4 && (
                  <CustomButton
                    type="button"
                    handleClick={handleSubmit}
                    disabled={value === 0 || movingApplicant}
                    backgroundColor="#3a6ed4"
                    color="#fff"
                    text="Move Applicant"
                    additionalClass="mx-3 mt-2"
                    loading={movingApplicant}
                  />
                )}

                {value === 4 && (
                  <CustomButton
                    type="button"
                    handleClick={() => handleOpenModal(currentApplicant)}
                    disabled={value === 0 || hiring}
                    backgroundColor="#3a6ed4"
                    color="#fff"
                    text="Hire Applicant"
                    additionalClass="mx-3 mt-2"
                    loading={hiring}
                  />
                )}
              </span>
            </span>
          </DialogActions>
        )}
      </Dialog>

      {/* ── Tier 3 Hiring Questionnaire Modal ──────────────────────────────── */}

      {/*   Only rendered / opened when jobTier === 3                          */}

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            width: "58rem",

            borderRadius: "1rem",

            padding: "0.75rem",
          },
        }}
      >
        {currentApplicant && jobApplicants && jobApplicants.length > 0 && (
          <>
            <DialogTitle
              style={{ marginTop: "4%", flex: 1 }}
              id="form-dialog-title"
            >
              <div className="d-flex justify-content-between align-items-center">
                <strong className="text-dark">
                  Hiring Questionnaire On Candidate
                </strong>

                <IconButton
                  onClick={handleCloseModal}
                  style={{
                    padding: "8px",

                    marginTop: "-10px",

                    marginRight: "-10px",
                  }}
                >
                  <svg width="24" height="24" className="rounded-circle">
                    <use href={`${icons}#close`}></use>
                  </svg>
                </IconButton>
              </div>
            </DialogTitle>

            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name of Applicant"
                    value={`${currentApplicant.first_name} ${currentApplicant.last_name}`}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name of Organization"
                    value={job?.campany_name || job?.company_name || ""}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Position to be held"
                    value={job?.role_title || ""}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </Grid>

                {/* Conditional salary input */}

                {showSalaryInput && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Agreed Annual Salary"
                      name="salaryID"
                      value={hiringPost.salaryID}
                      onChange={handleHiringPost}
                      placeholder="Enter agreed annual salary"
                      variant="outlined"
                      type="number"
                    />
                  </Grid>
                )}

                {/* Contract / offer letter upload */}

                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    style={{ marginBottom: "8px", fontWeight: "bold" }}
                  >
                    Kindly upload the page of the offer letter or employment
                    contract that shows the salary information.
                  </Typography>

                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleFileChange(e, currentApplicant, job)}
                    accept=".pdf,.doc,.docx,.txt,.rtf,image/*"
                    style={{
                      width: "100%",

                      padding: "10px",

                      border: "1px solid #ccc",

                      borderRadius: "4px",
                    }}
                  />
                </Grid>

                {/* ── Single placement-fee agreement checkbox (Tier 3 only) ── */}

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={placementFeeAgreement}
                        onChange={(e) =>
                          setPlacementFeeAgreement(e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        style={{ color: "red", fontWeight: "bold" }}
                      >
                        I agree to pay the outstanding balance of the placement
                        fee.
                      </Typography>
                    }
                  />
                </Grid>

                {/* Submit */}

                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: "16px" }}
                >
                  <CustomButton
                    backgroundColor="#3A6ED4"
                    color="#fff"
                    text="Submit"
                    disabled={isSubmitDisabled || submittingHiring}
                    loading={submittingHiring}
                    handleClick={() =>
                      handleHiringDetails(
                        currentApplicant.first_name,

                        currentApplicant.applicant_id,

                        job?.id,

                        job?.company_name,

                        job?.role_title,
                      )
                    }
                  />
                </Grid>
              </Grid>
            </DialogContent>
          </>
        )}
      </Dialog>

      {/* Decline Confirmation Dialog */}

      <Dialog
        open={openDeclineConfirm}
        onClose={handleCloseDeclineConfirm}
        aria-labelledby="decline-dialog-title"
        PaperProps={{
          style: {
            borderRadius: "1rem",

            padding: "0.5rem",

            maxWidth: "500px",
          },
        }}
      >
        <DialogTitle id="decline-dialog-title">
          <strong style={{ color: "#FF5964" }}>Decline Application</strong>
        </DialogTitle>

        <DialogContent>
          <p style={{ fontSize: "15px", margin: "1rem 0" }}>
            Are you sure you want to decline{" "}
            <strong>
              {currentApplicant?.first_name} {currentApplicant?.last_name}
              &apos;s
            </strong>{" "}
            application?
          </p>

          <p style={{ fontSize: "14px", color: "#6c757d" }}>
            This action will move the candidate to the &quot;Regret&quot; stage
            and they will be notified of the decision. This action cannot be
            undone.
          </p>
        </DialogContent>

        <DialogActions style={{ padding: "1rem 1.5rem" }}>
          <CustomButton
            type="button"
            handleClick={handleCloseDeclineConfirm}
            backgroundColor="#6c757d"
            color="#fff"
            text="Cancel"
            additionalClass="px-4"
          />

          <CustomButton
            type="button"
            handleClick={rejectApplication}
            backgroundColor="#FF5964"
            color="#fff"
            text="Confirm Decline"
            additionalClass="px-4 ml-2"
            loading={decliningApplication}
            disabled={decliningApplication}
          />
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={handleCloseProfile}>
        <DialogTitle id="form-dialog-title">
          Candidate&apos;s Profile
        </DialogTitle>

        <DialogContent>
          {user && (
            <div className="mt-3 px-2">
              <div className="profile-header d-flex">
                <img height="150" className="mr-5" src={user.image_url} />

                <div className="d-flex flex-column mt-2">
                  <h4 style={{ color: "#949494" }}>
                    {user.first_name} <b>{user.last_name}</b>
                  </h4>
                  {(user.location || user.country_name) && (
                    <p style={{ color: "#949494", marginTop: "8px" }}>
                      <i className="fa fa-map-marker mr-2"></i>
                      {[user.location, user.country_name].filter(Boolean).join(', ')}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="profile-about">
            <div className="section-header mt-5">
              <p className="mb-0">About</p>
            </div>

            <p className="co-darkgray mt-4">
              {user?.about || "Nothing to display"}
            </p>
          </div>

          <div className="profile-notes">
            <div className="section-header mt-5">
              <p className="mb-0">RECRUITER NOTES</p>
            </div>

            <div className="mt-3">
              <p className="co-darkgray">{note || "No notes added yet."}</p>

              <CustomButton
                text="Add/Edit Notes"
                handleClick={() => setOpenNotesModal(true)}
                backgroundColor="#3a6ed4"
                color="#fff"
                additionalClass="mt-2"
              />
            </div>
          </div>

          <div className="profile-education">
            <div className="section-header mt-5">
              <p className="mb-0">EDUCATION/CERTIFICATIONS</p>
            </div>

            {user?.education.length ? (
              user.education.map((data, index) => (
                <div className={`education edu_link${index + 1}`} key={data.id}>
                  <p className="co-darkgray medium-text">{data.school}</p>

                  <p>{`${data.degree} ${data.field_of_study} (${ternaryResolver(
                    `${data.end_date}`.toLowerCase() === "present",

                    data.end_date,

                    new Date(data?.end_date).getFullYear(),
                  )})`}</p>
                </div>
              ))
            ) : (
              <div className="mt-4">
                <p className="co-darkgray">Nothing to display</p>
              </div>
            )}
          </div>

          <div className="profile-skills">
            <div className="section-header mt-5">
              <p className="mb-0">SKILLS/INTERESTS</p>
            </div>

            <ul className="d-flex flex-wrap mt-3">
              {user?.skills?.length ? (
                user?.skills?.map((skill) => (
                  <li
                    key={skill}
                    className="mr-2 py-1 px-2 outlined"
                    style={{ marginTop: "10px" }}
                  >
                    {skill}
                  </li>
                ))
              ) : (
                <li className="mr-2 py-1 px-2 co-darkgray">No skill added</li>
              )}
            </ul>
          </div>

          <div className="profile-documents">
            <div className="section-header mt-5">
              <p className="mb-0">RESUME/DOCUMENTS</p>
            </div>

            <div className="d-flex flex-column mt-3">
              {user?.resume && (
                <a
                  className="d-flex my-2 cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();

                    handleViewDocument(user.resume, "Resume");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <svg width="20" height="24" className="mr-2">
                    <use href={`${icons}#file`}></use>
                  </svg>
                  Rèsumé
                  <span className="flag mx-3 co-primary small-text px-1">
                    Default
                  </span>
                </a>
              )}

              {user?.links && (
                <span className="d-flex my-2">
                  <svg width="22" height="22" className="mr-2">
                    <use href={`${icons}#link`}></use>
                  </svg>

                  {user?.links[0]?.facebook && (
                    <a
                      className="underlined co-primary mr-2"
                      href={user.links[0].facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  )}

                  {user?.links[0]?.linkdn && (
                    <a
                      className="underlined co-primary mr-2"
                      href={user.links[0].linkdn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  )}

                  {user?.links[0]?.twitter && (
                    <a
                      className="underlined co-primary mr-2"
                      href={user.links[0].twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Twitter
                    </a>
                  )}

                  {user?.links[0]?.potfolio && (
                    <a
                      className="underlined co-primary"
                      href={user.links[0].potfolio}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Portfolio
                    </a>
                  )}

                  {[
                    !user?.resume,

                    !user?.links[0]?.facebook,

                    !user?.links[0]?.linkdn,

                    !user?.links[0]?.twitter,

                    !user?.links[0]?.potfolio,
                  ].every((val) => val === true) && (
                    <p className="mr-2 py-1 px-2 co-darkgray">
                      Nothing to display
                    </p>
                  )}
                </span>
              )}
            </div>
          </div>

          <div className="profile-education">
            <div className="section-header mt-5">
              <p className="mb-0">EXPERIENCES</p>
            </div>

            {Array.isArray(experiences) && experiences?.length ? (
              experiences.map((data, index) => (
                <div className={`education edu_link${index + 1}`} key={data.id}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p style={{ color: "#3A6ED4" }}>COMPANY NAME</p>

                      <p className="co-darkgray medium-text">
                        {data.campany_name}
                      </p>
                    </div>

                    <div>
                      <p style={{ color: "#3A6ED4" }}>JOB POSITION</p>

                      <p>{data.title}</p>
                    </div>

                    <div>
                      <p style={{ color: "#3A6ED4" }}>START DATE</p>

                      <p>{data.start_date}</p>
                    </div>

                    <div>
                      <p style={{ color: "#3A6ED4" }}>END DATE</p>

                      <p>{data.end_date}</p>
                    </div>
                  </div>

                  <div>
                    <p style={{ color: "#3A6ED4" }}>ACHIEVEMENTS</p>

                    <p>{data.achievements.replace(/<\/?[^>]+(>|$)/g, "")}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="mt-4">
                <p className="co-darkgray">Nothing to display</p>
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center align-center">
          <Button onClick={handleCloseProfile} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notes Edit Modal */}

      <Dialog
        open={openNotesModal}
        onClose={() => setOpenNotesModal(false)}
        aria-labelledby="notes-dialog-title"
        PaperProps={{
          style: {
            width: "50rem",

            borderRadius: "1rem",

            padding: "0.75rem",
          },
        }}
      >
        <DialogTitle id="notes-dialog-title">Edit Recruiter Notes</DialogTitle>

        <DialogContent>
          <textarea
            className="form-control"
            rows="6"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Enter your notes about this candidate..."
            disabled={savingNote}
          />
        </DialogContent>

        <DialogActions>
          <CustomButton
            text="Cancel"
            handleClick={() => setOpenNotesModal(false)}
            backgroundColor="#6c757d"
            color="#fff"
            additionalClass="mr-2"
            disabled={savingNote}
          />

          <CustomButton
            text="Save"
            handleClick={handleSaveNote}
            backgroundColor="#3a6ed4"
            color="#fff"
            loading={savingNote}
            disabled={savingNote}
          />
        </DialogActions>
      </Dialog>

      {/* Placement Fee Info Dialog */}

      <Dialog open={openPlacement} onClose={handleClosePlacement}>
        <DialogTitle id="form-dialog-title">Important Information</DialogTitle>

        <DialogContent>
          <strong>
            Please note that a placement fee of{" "}
            <span className="text-danger">{salaryPlacement} </span>
            has been deducted from your salary
          </strong>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center align-center">
          <Button onClick={handleClosePlacement} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ResumeHoverPreview
        open={Boolean(hoverPreviewApplicant && hoverAnchorEl)}
        anchorEl={hoverAnchorEl}
        applicant={hoverPreviewApplicant}
        onClose={clearHoverPreview}
        onOpenFull={handleOpenFullResume}
        onMouseEnter={handlePreviewMouseEnter}
        onMouseLeave={scheduleHideHoverPreview}
      />

      <DocumentViewer
        open={openDocumentViewer}
        onClose={handleCloseDocumentViewer}
        documentUrl={currentDocument.url}
        documentName={currentDocument.name}
      />

      {/* Notes View Modal */}

      <Dialog
        open={openNotesViewModal}
        onClose={handleCloseNotesView}
        aria-labelledby="notes-view-dialog-title"
        PaperProps={{
          style: {
            width: "40rem",

            borderRadius: "1rem",

            padding: "1rem",
          },
        }}
      >
        <DialogTitle id="notes-view-dialog-title">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Notes for {currentApplicant?.first_name}{" "}
              {currentApplicant?.last_name}
            </span>

            <IconButton onClick={handleCloseNotesView}>
              <svg width="24" height="24" className="rounded-circle">
                <use href={`${icons}#close`}></use>
              </svg>
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="mb-3">
            <strong>Current Notes:</strong>
          </div>

          <div
            className="p-3 border rounded bg-light"
            style={{
              minHeight: "100px",

              maxHeight: "200px",

              overflowY: "auto",

              whiteSpace: "pre-wrap",

              fontFamily: "inherit",

              fontSize: "0.95rem",

              lineHeight: "1.5",
            }}
          >
            {currentNote || "No notes available for this candidate."}
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-between">
          <Button onClick={handleCloseNotesView} color="default">
            Close
          </Button>

          <CustomButton
            text="Edit Notes"
            handleClick={handleOpenNotesEdit}
            backgroundColor="#3a6ed4"
            color="#fff"
          />
        </DialogActions>
      </Dialog>

      {/* Bulk Move Modal */}

      <Dialog
        open={openBulkMoveModal}
        onClose={handleCloseBulkMoveModal}
        aria-labelledby="bulk-move-dialog-title"
        PaperProps={{
          style: {
            width: "35rem",

            borderRadius: "1rem",

            padding: "0.75rem",
          },
        }}
      >
        <DialogTitle id="bulk-move-dialog-title">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Move {selectedCandidates.length} Candidate
              {selectedCandidates.length > 1 ? "s" : ""}
            </span>

            <IconButton
              onClick={handleCloseBulkMoveModal}
              style={{
                backgroundColor: "#eff1f3",

                width: "32px",

                height: "32px",

                padding: "0",

                borderRadius: "50%",

                marginLeft: "10px",
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5e6c84"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>

                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="mb-3">
            <label className="font-weight-bold mb-2">Select Stage:</label>

            <select
              className="form-control"
              value={selectedStage}
              onChange={(e) => setSelectedStage(e.target.value)}
              disabled={bulkMoving}
            >
              <option value="">-- Select Stage --</option>

              <option value="1" disabled={isStageDisabledForBulkMove(1)}>
                Consider
              </option>

              <option value="2" disabled={isStageDisabledForBulkMove(2)}>
                Test
              </option>

              <option value="3" disabled={isStageDisabledForBulkMove(3)}>
                Interview
              </option>

              <option value="5">Reject</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="font-weight-bold mb-2">Reason (Optional):</label>

            <textarea
              className="form-control"
              rows="4"
              value={bulkMoveReason}
              onChange={(e) => setBulkMoveReason(e.target.value)}
              placeholder="Enter reason for moving candidates..."
              disabled={bulkMoving}
            />
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-between">
          <CustomButton
            text="Cancel"
            handleClick={handleCloseBulkMoveModal}
            disabled={bulkMoving}
            backgroundColor="#e3e3e3"
            color="#333333"
            additionalClass="d-flex justify-content-center align-items-center px-4"
          />

          <CustomButton
            text={bulkMoving ? "Moving..." : "Move Candidates"}
            handleClick={handleBulkMove}
            backgroundColor="#3a6ed4"
            color="#fff"
            loading={bulkMoving}
            additionalClass="d-flex justify-content-center align-items-center"
          />
        </DialogActions>
      </Dialog>

      {/* AI Recommendation Modal */}

      <Dialog
        open={openRecommendationModal}
        onClose={() => setOpenRecommendationModal(false)}
        aria-labelledby="recommendation-dialog-title"
        PaperProps={{
          style: {
            width: "40rem",

            borderRadius: "1rem",

            padding: "0.75rem",
          },
        }}
      >
        <DialogTitle id="recommendation-dialog-title">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-0 font-weight-bold">AI Recommendation</h6>

            <IconButton onClick={() => setOpenRecommendationModal(false)}>
              <svg width="24" height="24" className="rounded-circle">
                <use href={`${icons}#close`}></use>
              </svg>
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="mb-4">
            <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
              {currentRecommendation}
            </Typography>
          </div>
        </DialogContent>

        <DialogActions>
          <CustomButton
            text="Close"
            handleClick={() => setOpenRecommendationModal(false)}
            backgroundColor="#e3e3e3"
            color="#333333"
            additionalClass="px-4"
          />
        </DialogActions>
      </Dialog>

      {/* Hire Confirmation Modal (Tier 1 & 2 only) */}
      <Dialog
        open={openHireConfirm}
        onClose={handleCloseHireConfirm}
        aria-labelledby="hire-confirm-dialog-title"
        PaperProps={{
          style: {
            width: "32rem",
            borderRadius: "1rem",
            padding: "1rem",
          },
        }}
      >
        <DialogTitle id="hire-confirm-dialog-title">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0 font-weight-bold" style={{ color: "#3a6ed4" }}>
              Confirm Hiring Action
            </h5>
            <IconButton
              onClick={handleCloseHireConfirm}
              disabled={hiring}
              style={{
                backgroundColor: "#eff1f3",
                width: "32px",
                height: "32px",
                padding: "0",
                borderRadius: "50%",
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5e6c84"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="mb-3">
            <div
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "8px",
                padding: "1rem",
                marginBottom: "1rem",
              }}
            >
              <div className="d-flex align-items-start">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#856404"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginRight: "0.75rem", flexShrink: 0 }}
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <div>
                  <Typography
                    variant="body1"
                    style={{ fontWeight: 600, color: "#856404", marginBottom: "0.5rem" }}
                  >
                    Important: This is a critical action
                  </Typography>
                  <Typography variant="body2" style={{ color: "#856404" }}>
                    You are about to move this candidate to <strong>Hired</strong> status. 
                    This action will mark them as successfully hired for this position.
                  </Typography>
                </div>
              </div>
            </div>

            {currentApplicant && (
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  padding: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <Typography variant="body2" style={{ color: "#6c757d", marginBottom: "0.5rem" }}>
                  Candidate:
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 600, color: "#212529" }}>
                  {currentApplicant.first_name} {currentApplicant.last_name}
                </Typography>
                {currentApplicant.email && (
                  <Typography variant="body2" style={{ color: "#6c757d", marginTop: "0.25rem" }}>
                    {currentApplicant.email}
                  </Typography>
                )}
              </div>
            )}

            <Typography variant="body2" style={{ color: "#6c757d", marginTop: "1rem" }}>
              Please confirm that you want to proceed with hiring this candidate.
            </Typography>
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-between" style={{ padding: "1rem" }}>
          <CustomButton
            text="Cancel"
            handleClick={handleCloseHireConfirm}
            disabled={hiring}
            backgroundColor="#e3e3e3"
            color="#333333"
            additionalClass="d-flex justify-content-center align-items-center px-4"
          />

          <CustomButton
            text={hiring ? "Hiring..." : "Confirm Hire"}
            handleClick={handleConfirmHire}
            backgroundColor="#28a745"
            color="#fff"
            loading={hiring}
            disabled={hiring}
            additionalClass="d-flex justify-content-center align-items-center px-4"
          />
        </DialogActions>
      </Dialog>

      {/* Job Details Modal */}
      {job && openJobDetailsModal && (
        <CustomModal
          isOpen={openJobDetailsModal}
          onClose={() => setOpenJobDetailsModal(false)}
          title={job?.role_title || "Job Details"}
          maxWidth="800px"
        >
          <ViewDetails job={job} section="details" />
        </CustomModal>
      )}
    </div>
  );
};

export default Applicants;
